// data.js
export const experienceData = {
  frontend: [
    { name: "HTML", level: "Experienced" },
    { name: "CSS", level: "Experienced" },
    { name: "Tailwind", level: "Experienced" },
    { name: "Javascript", level: "Experienced" },
    { name: "Typescript", level: "Experienced" },
    { name: "SCSS", level: "Experienced" },
    { name: "React", level: "Experienced" },
    { name: "Redux", level: "Experienced" },
    { name: "MUI", level: "Experienced" },
    { name: "Next Js", level: "Experienced" },
    { name: "Bootstrap", level: "Intermediate" },
  ],
  backend: [
    { name: "Node Js", level: "Experienced" },
    { name: "MongoDb", level: "Experienced" },
    { name: "MySQL", level: "Experienced" },
    { name: "Postgres", level: "Experienced" },
    { name: "Express Js", level: "Experienced" },
    { name: "Nest Js", level: "Experienced" },
    { name: "Redis", level: "Experienced" },
    { name: "Supabase", level: "Intermediate" },
    { name: "Prisma", level: "Experienced" },
    { name: "PHP", level: "Experienced" },
    { name: "Laravel", level: "Experienced" },
    { name: "Python", level: "Basic" },
    { name: "Docker", level: "Basic" },
  ],
};
